import { useTranslation } from 'react-i18next';
import { IconFire } from "../../elements/Icon";

export const Strike = ({ onClose }) => {
    const { t } = useTranslation();

    const storage = localStorage.getItem('streak');

    return (
        <div
            onClick={onClose}
            className="w-full h-full absolute z-[60] bg-bgBlack/30 flex justify-center items-center"
        >
            <div
                onClick={(e) => e.stopPropagation()}
                className="
                            relative
                            w-[297px] h-[205px]
                            md:w-[333px] md:h-[261px]
                            lg:w-[383px] lg:h-[264px]
                            xl:w-[484px] xl:h-[334px]
                            rounded-[19px]
                            border-[3px] md:border-[4px]
                            border-[#7743BA]
                            bg-[#FCF9EE]
                            bg-[url('/backGrounds/firework2.svg')]
                            bg-no-repeat
                            bg-center
                            bg-contain"
            >
               

                <div className="absolute inset-0 flex items-center justify-center">
                    <IconFire className="w-[48px] h-[50px] md:w-[63px] md:h-[65px] xl:w-[89px] xl:h-[92px]" />
                </div>

                <div className="absolute bottom-[34px] md:bottom-[53px] lg:bottom-[48px] xl:bottom-[52px] w-full px-4">
                    <p className="text-[16px] md:text-[20px] lg:text-[24px] text-[#4B96C9] text-center font-fredokaOne leading-tight leading-[0]">
                        {t("day_streak").replace("X", storage)}
                    </p>
                </div>


            </div>
        </div>
    );
};
